<div id="sphericalImageOverlay" class="gallery__image360" (click)="$event.stopPropagation()"></div>
